(() => {
  if (window.__shammaBestColorToggle) return;
  window.__shammaBestColorToggle = true;

  const activate = (btn) => {
    const card = btn.closest(".shamma-best__card");
    if (!card) return;

    const idx = btn.getAttribute("data-cidx");
    card
      .querySelectorAll(
        ".shamma-best__pane, .shamma-best__price-pane, .shamma-best__activities-pane",
      )
      .forEach((el) => {
        el.hidden = el.getAttribute("data-cidx") !== idx;
      });

    card.querySelectorAll(".shamma-best__swatch").forEach((item) => {
      const selected = item === btn;
      item.classList.toggle("is-selected", selected);
      item.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    const url = btn.getAttribute("data-url");
    if (url) {
      card
        .querySelectorAll("a.shamma-best__media, .shamma-best__title a, a.shamma-best__choose")
        .forEach((link) => {
          link.href = url;
        });
    }

    const input = card.querySelector(".shamma-best__variant-id");
    const variantId = btn.getAttribute("data-variant-id");
    if (input && variantId) {
      input.value = variantId;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const atc = card.querySelector(".shamma-best__atc");
    if (atc) {
      atc.disabled = btn.getAttribute("data-available") === "false";
    }
  };

  document.addEventListener(
    "click",
    (event) => {
      const btn = event.target.closest(".shamma-best__swatch");
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      activate(btn);
    },
    true,
  );
})();
